<template>
	<div>
		<v-fade-transition mode='out-in'>
			<div class='transition-wrapper' :key='currentSlotName'>
				<slot :name='currentSlotName' />
			</div>
		</v-fade-transition>
	</div>
</template>

<script>
const DEFAULT_TIME_TO_SHOW = 5000;

export default {
	name: 'CardPresenter',
	props: {
		timePerPage: {
			type: [Number, Array],
			required: true
		}
	},
	data() {
		return {
			currentSlotName: null,
			slotsNames: [],
			interval: null
		};
	},
	mounted() {
		const slotsNames = Object.keys(this.$scopedSlots),
			[firstSlotName] = slotsNames;
		this.slotsNames = slotsNames;
		this.currentSlotName = firstSlotName;

		this.$emit('page-changed', 0)
		this.$nextTick(() => {
			setTimeout(() => {
				this.handlePageScrolling();
			}, this.getTimePerPage(0));
		});

	},
	methods: {
		handlePageScrolling() {
			const currentIndex = this.slotsNames.findIndex(sns => sns === this.currentSlotName),
				nextIndexCanBeSelected = currentIndex + 1 >= this.slotsNames.length,
				nextIndex = nextIndexCanBeSelected ?
					0 :
					currentIndex + 1,
				timeToShowPage = this.getTimePerPage(nextIndex);
			this.currentSlotName = this.slotsNames[nextIndex];

			setTimeout(this.handlePageScrolling, timeToShowPage);
			this.$emit('page-changed', nextIndex)
		},
		getTimePerPage(nextIndex) {
			if (Array.isArray(this.timePerPage)) {
				return this.timePerPage[nextIndex] || DEFAULT_TIME_TO_SHOW;
			} else {
				return this.timePerPage;
			}
		}
	}
};
</script>

<style scoped>

</style>
